import api from "./api";

// Mantenimiento de los parametros del sistema (tabla configuracion). Aqui se
// enciende y apaga la bitacora de cambios: el parametro BITACORA_ACTIVA.

export const getsConfiguracion = async () => {
    const response = await api.get("/Configuracion/GetsConfiguracion");

    return response.data.data;
}

export const getConfiguracion = async (idConfiguracion) => {
    const response = await api.get("/Configuracion/GetConfiguracion?idConfiguracion=" + idConfiguracion);

    return response.data.data;
}

export const addUpdateConfiguracion = (dataPost) =>
    api.post("/Configuracion/AddUpdateConfiguracion", dataPost);

export const deleteConfiguracion = (idConfiguracion) =>
    api.post("/Configuracion/DeleteConfiguracion?idConfiguracion=" + idConfiguracion);
